import { Component, HostBinding, Inject, Input } from '@angular/core';

import { ITeaserBetMessages } from '../../../../base/models/betslip-messages';
import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../base/services/betslip-messages-provider.service';

@Component({
    selector: 'bs-digital-result-succeeded-teaser-info',
    templateUrl: './result-succeeded-pick-teaser-info.component.html',
    styleUrls: ['./result-succeeded-pick-teaser-info.component.scss'],
    standalone: false,
})
export class ResultSucceededPickteaserInfoComponent {
    @Input() picksCount: number;
    @Input() teaserPoints = 5;
    teaserBetMessages: ITeaserBetMessages | undefined;

    @HostBinding('class') className = 'teaser-info';

    constructor(@Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messageProvider: IBetslipMessagesProviderService) {
        const betslipMessages = messageProvider.getMessages();
        this.teaserBetMessages = betslipMessages.teaserBet;
    }
}
